import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Detect the specific chunk load error from Vercel/React
    if (
      error?.message?.includes("Loading chunk") ||
      error?.message?.includes("chunk failed") ||
      error?.message?.includes("Loading CSS chunk")
    ) {
      // Force a hard reload to get the newest deployment files
      window.location.reload();
      return { hasError: true };
    }
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // This only shows if it's NOT a chunk error (since chunk errors auto-reload)
      return (
        <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center p-6">
          <h2 className="text-2xl font-bold mb-4">Something went wrong</h2>
          <p className="text-gray-400 mb-6">An unexpected error occurred.</p>
          <button
            onClick={() => window.location.reload()}
            className="bg-blue-600 hover:bg-blue-700 px-6 py-3 rounded-full font-semibold transition-colors"
          >
            Reload App
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
